export default [
  {
    title: 'menu.home',
    route: 'home',
    icon: 'HomeIcon',
    access_nivel: [1, 2, 3],
  },
  {
    title: 'menu.teamBoarding',
    route: 'team-boarding',
    icon: 'AnchorIcon',
    access_nivel: [1, 2, 3],
    ability: 'equipe.ver',
  },
  {
    title: 'menu.occurrences',
    route: 'occurrences',
    icon: 'MapPinIcon',
    access_nivel: [1, 2, 3],
  },
  {
    title: 'menu.regulation',
    route: 'regulacao',
    icon: 'ActivityIcon',
    access_nivel: [1, 2, 3],
    ability: 'regulacao.ver',
  },
  {
    title: 'menu.dispatch',
    route: 'despacho',
    icon: 'TruckIcon',
    access_nivel: [1, 2, 3],
    ability: 'despacho.ver',
  },
  {
    title: 'menu.retentions',
    route: 'list-retentions',
    icon: 'PackageIcon',
    access_nivel: [1],
  },
  {
    title: 'menu.professionals',
    icon: 'UsersIcon',
    access_nivel: [1],
    children: [
      {
        title: 'menu.professionals_list',
        route: 'list-professionals',
        access_nivel: [1],
      },
      {
        title: 'menu.professional_types',
        route: 'list-professional-types',
        access_nivel: [1],
      },
      {
        title: 'menu.teams',
        route: 'list-teams',
        access_nivel: [1],
      },
      {
        title: 'menu.team_types',
        route: 'list-team-types',
        access_nivel: [1],
      },
      {
        title: 'menu.roles',
        route: 'list-roles',
        access_nivel: [1],
        ability: 'rbac.gerenciar',
      },
    ],
  },
  {
    title: 'menu.registers',
    icon: 'FileTextIcon',
    access_nivel: [1],
    children: [
      {
        title: 'menu.areas',
        route: 'list-areas',
        access_nivel: [1],
      },
      {
        title: 'menu.cbos',
        route: 'list-cbos',
        access_nivel: [1],
      },
      {
        title: 'menu.cities',
        route: 'list-cities',
        access_nivel: [1],
      },
      //{
      //  title: 'Classificações',
      //  route: 'list-classifications',
      //  access_nivel: [1],
      // },
      {
        title: 'menu.cids',
        route: 'list-cids',
        access_nivel: [1],
      },
      {
        title: 'menu.disciplines',
        route: 'list-discipline',
        access_nivel: [1],
      },
      {
        title: 'menu.companies',
        route: 'list-companies',
        access_nivel: [1],
      },
      {
        title: 'menu.equipment_allocations',
        route: 'list-equipment-allocations',
        access_nivel: [1],
      },
      {
        title: 'menu.involveds',
        route: 'list-involveds',
        access_nivel: [1],
      },
      {
        title: 'menu.companion_types',
        route: 'list-companion-types',
        access_nivel: [1],
      },
      {
        title: 'menu.establishments',
        route: 'list-establishments',
        access_nivel: [1],
      },
      {
        title: 'menu.establishment_types',
        route: 'list-establishment-types',
        access_nivel: [1],
      },
      {
        title: 'menu.rejection_types',
        route: 'list-rejection-types',
        access_nivel: [1],
      },
      {
        title: 'menu.pois',
        route: 'list-pois',
        access_nivel: [1],
      },
      {
        title: 'menu.poi_types',
        route: 'list-poi-types',
        access_nivel: [1],
      },
      //{
      //  title: 'Tipos de Veículos',
      //  route: 'list-vehicle-types',
      //  access_nivel: [1],
      //},
      {
        title: 'menu.ufs',
        route: 'list-ufs',
        access_nivel: [1],
      },
      {
        title: 'menu.users',
        route: 'list-users',
        access_nivel: [1],
        ability: 'usuario.gerenciar',
      },
      // {
      //  title: 'Veículos',
      //  route: 'list-vehicles',
      // access_nivel: [1],
      //},
    ],
  },
  {
    title: 'menu.nodeStructure',
    icon: 'GitBranchIcon',
    access_nivel: [1],
    children: [
      {
        title: 'menu.node_types',
        route: 'list-node-types',
        access_nivel: [1],
        ability: 'node.admin',
      },
      {
        title: 'menu.nodes',
        route: 'list-nodes',
        access_nivel: [1],
        ability: 'node.admin',
      },
    ],
  },
]
